<template>
    <div>
        <action-bar>
            <router-link to="/online-factor-item-create" class="btn btn-success">{{ $t('online-factor.label_create_item') }}</router-link>
        </action-bar>
        <online-factor-filter :action="filterAction"></online-factor-filter>
        <online-factor-items-with-manage 
            v-if="$can('read', 'payment-link')"
            :query="query"
            @filter="filterAction"
        ></online-factor-items-with-manage>
        <online-factor-items-without-manage 
            v-else 
            :query="query"
            @filter="filterAction"
        ></online-factor-items-without-manage>
    </div>
</template>

<script>
import Filter from './components/filter_item'
import actionBar from '@/components/custom/action-bar'
import ItemsWithManageAccess from './ItemsWithManageAccess.vue';
import ItemsWithoutManageAccess from './ItemsWithoutManageAccess.vue';

export default {
    name: 'online-factor-get-items',
    components:{
        'online-factor-filter': Filter,
        'action-bar': actionBar,
        'online-factor-items-with-manage': ItemsWithManageAccess,
        'online-factor-items-without-manage': ItemsWithoutManageAccess
    },
    data() {
        return {
            query: {} 
        };
    },
    methods: {
        filterAction(e, query) {
            this.query = query;
            this.$emit('filter', e, query);
        }
    },
}
</script>